<template>
  <div class="audience">
    <!-- Chargement -->
    <div v-if="loading" class="text-xs-center">
      <v-progress-circular indeterminate class="primary--text" :size="100" :width="1"></v-progress-circular>
    </div>
    <div v-else>
      <v-card>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs6 sm3 md2>
              <div class="grey--text text--darken-2">{{ $t('trackedPages') | cap }}</div>
              <div class="headline teal--text">{{ nbLoads }}</div>
            </v-flex>
            <v-flex xs6 sm3 md2>
              <div class="grey--text text--darken-2">{{ $tc('visitors', 2, { count: '' }) | cap }}</div>
              <div class="headline blue--text">{{ nbVisitors }}</div>
            </v-flex>
            <v-flex xs6 sm3 md2>
              <div class="grey--text text--darken-2">{{ $tc('chats', 2, { count: '' }) | cap }}</div>
              <div class="headline pink--text">{{ nbChats }}</div>
            </v-flex>
            <v-flex xs6 sm3 md2>
              <div class="grey--text text--darken-2">{{ $t('conversationRate') | cap }}</div>
              <div class="headline primary--text">{{ conversation }} %</div>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-select 
                :label="$t('dataInterval') | cap"
                :items="intervals" 
                v-model="interval" 
                return-object
              ></v-select>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-btn color="primary" dark flat @click="download()">{{ $t('exportInCsv') }}<v-icon color="primary" right>file_download</v-icon></v-btn>
            </v-flex>
          </v-layout>
          <highcharts :options="options"></highcharts>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import * as moment from 'moment'
import json2csv from 'json2csv'
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      loading: false,

      intervals: [
         { text: _.upperFirst(this.$t('per')) + ' ' + this.$tc('days', 1, {count: ''}), value: 1 },
         { text: _.upperFirst(this.$t('per')) + ' ' + this.$tc('months', 1, {count: ''}), value: 2 }
      ],
      interval: null,

      resFromAjax: null,

      options: {
        chart: {
          height: 300
        },
        title: {
          text: '',
          x: -20 // center
        },
        tooltip: {
          shared: true,
          borderColor: '#cccccc',
          crosshairs: true
        },
        xAxis: {
          categories: [] // à remplir par l'appel ajax
        },
        yAxis: [
          {
            allowDecimals: false,
            title: { text: '' },
            opposite: false
          },
          { // petites valeurs entières
            allowDecimals: false,
            labels: {
              format: '{value}',
              style: {
                color: 'rgba(233, 30, 99, 1)'
              }
            },
            title: {
              text: this.$t('chats2'),
              style: {
                color: 'rgba(233, 30, 99, 1)'
              }
            },
            opposite: true
          }
        ],
        series: [
          {
            name: this.$t('trackedPages'),
            type: 'area',
            color: 'rgba(0, 150, 136, 0.8)', // teal
            marker: {symbol: 'circle', enabled: false},
            visible: true,
            yAxis: 0,
            data: [] // à remplir par l'appel ajax
          },
          {
            name: _.upperFirst(this.$tc('visitors', 2, { count: '' })),
            type: 'area',
            color: 'rgba(33, 150, 243, 0.8)', // blue
            marker: {symbol: 'circle', enabled: false},
            visible: true,
            yAxis: 0,
            data: [] // à remplir par l'appel ajax
          },
          {
            name: _.upperFirst(this.$tc('chats', 2, { count: '' })),
            type: 'column',
            color: 'rgba(233, 30, 99, 0.8)', // pink
            marker: {symbol: 'circle', enabled: false},
            visible: true,
            yAxis: 1,
            data: [] // à remplir par l'appel ajax
          }
        ],
        exporting: {
          enabled: true
        },
        navigation: {
          buttonOptions: {
            verticalAlign: 'bottom',
            y: -15,
            x: -20
          }
        },
        credits: {
          enabled: false
        }
      },
      dialogProgress: false
    }
  },

  computed: {
    ...mapGetters('_Stats', ['params']),
    nbLoads () {
      return _.sumBy(this.resFromAjax, 'loads')
    },
    nbVisitors () {
      return _.sumBy(this.resFromAjax, 'visitors')
    },
    nbChats () {
      return _.sumBy(this.resFromAjax, 'chats')
    },
    conversation () {
      return this.nbVisitors !== 0
        ? _.round(((this.nbChats / this.nbVisitors) * 100), 2)
        : 0
    }
  },

  mounted () {
    // si les filtres sont chargés, il est possible de lancé la/les requêtes afin de remplir les stats
    this.loading = true
    // définition de l'intervalle à afficher dans le graphique
    this.interval = this.intervals[0]
    this.getAudienceData()
    // if (!this.$cookie.get('blockInstallProgress') && this.$store.state._User.ongoingTuto) {
    //   this.openDialogProgress()
    // }
    // si il y a un id visiteur en sessionStorage il faut ouvrir un chat directement
    console.log('audience :: this.directChat', this.directChat)
    if (this.directChat) {
      console.log('audience :: il y a un chat en session')
      this.$router.push({path: '/trafic/attente'})
    }
  },

  methods: {
    getAudienceData () {
      this.loading = true
      // execution de la requête en fonction des filtres
      this.axios.get('get/audience.php?' + this.params)
      .then(response => {
        this.resFromAjax = response.data
        this.updateSeries()
      })
      .catch(errors => {})
      .then(_ => {
        this.loading = false
      })
    },
    updateSeries () {
      // vide les tableau contenant les dates et les infos précédentes
      this.options.xAxis.categories = []
      this.options.series[0].data = []
      this.options.series[1].data = []
      this.options.series[2].data = []
      // parcours le tableau des infos dans la réponse
      if (this.interval.value === 1) { // par jour
        _.forEach(this.resFromAjax, day => {
          this.options.xAxis.categories.push(moment(day.date).format('ddd D MMM YY'))
          this.options.series[0].data.push(day.loads)
          this.options.series[1].data.push(day.visitors)
          this.options.series[2].data.push(day.chats)
        })
      } else { // par mois
        _.forEach(this.resFromAjax, day => {
          // vérifie que le mois du jour parcouru n'est pas déjà présent dans le tableau des x
          let found = -1
          for (var i = 0; i < this.options.xAxis.categories.length; i++) {
            if (this.options.xAxis.categories[i] === moment(day.date).format('MMMM YYYY')) {
              found = i
            }
          }
          if (found === -1) {
            // ajout du mois dans le tableau des x
            this.options.xAxis.categories.push(moment(day.date).format('MMMM YYYY'))
            this.options.series[0].data.push(day.loads)
            this.options.series[1].data.push(day.visitors)
            this.options.series[2].data.push(day.chats)
          }
          // ajout des valeurs dans le mois correspondant
          this.options.series[0].data[found] += day.loads
          this.options.series[1].data[found] += day.visitors
          this.options.series[2].data[found] += day.chats
        })
      }
      // type de graphique en fonction du nombre de jour de l'intervalle
      if (this.$parent.nbDays === 1 || this.interval.value !== 1) {
        this.options.series[0].type = 'column'
        this.options.series[1].type = 'column'
      } else {
        this.options.series[0].type = 'area'
        this.options.series[1].type = 'area'
      }
    },
    download () {
      let csv = null
      let fields = [
        'date',
        this.options.series[0].name,
        this.options.series[1].name,
        this.options.series[2].name
      ]
      // ajout de toute les données
      let dataToExport = []
      for (let i = 0; i < this.options.xAxis.categories.length; i++) {
        let value = []
        value[fields[0]] = this.options.xAxis.categories[i]
        value[fields[1]] = this.options.series[0].data[i]
        value[fields[2]] = this.options.series[1].data[i]
        value[fields[3]] = this.options.series[2].data[i]
        dataToExport.push(value)
      }
      try {
        csv = json2csv({ data: dataToExport, del: ';', fields: fields })
      } catch (err) {
        return
      }

      // téléchargement du fichier csv
      var hiddenElement = document.createElement('a')
      hiddenElement.href = 'data:attachment/text,' + encodeURI(csv)
      hiddenElement.target = '_blank'
      hiddenElement.download = 'audience.csv'
      document.body.appendChild(hiddenElement)
      hiddenElement.click()
    },
    // ---------------------------
    // close dialog Progression install
    fermeDialogProgress () {
      this.dialogProgress = false
    },
    // ---------------------------
    // Ouvre la dialogueBox de progression de l'installation
    openDialogProgress () {
      this.dialogProgress = true
    }
  },

  watch: {
    params (v) {
      this.getAudienceData()
    },
    // au changement d'intervalle, il faut actualiser les series du graphique
    interval: function (val, oldVal) {
      this.updateSeries()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/stats/Audience.vue